<template>
  <div id="createOrder1" class="container lv2Text">
    <div class="lv3Text t">填写订单信息</div>
    <div class="box">
      <div align="right">
        <router-link to="/user/address/0">
          <el-button type="text">管理收货地址</el-button>
        </router-link>
      </div>
      <div class="box2 address">
        <div v-if="_.size(addressList)>0">
          <el-row>
            <el-col :span="16">
              <div>
                <div>
                  <span>收货人：{{address.split(";")[1]}}</span>
                </div>
                <div>
                  <span>联系电话：{{address.split(";")[0]}}</span>
                </div>
                <div>
                  <span>收货地址：{{address.split(";")[2]+" "+address.split(";")[3]+" "+address.split(";")[4]+" "+address.split(";")[5]}}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="8" align="right">
              <div class="adr-btn">
                <el-button type="text">
                  <el-popover v-model="addressV" placement="bottom-end" width="500" trigger="click">
                    <div>
                      <div
                        v-for="(item,index) of addressList"
                        :key="index"
                        style="margin-bottom:20px"
                      >
                        <div>
                          <el-row>
                            <el-col :span="18">
                              <div>
                                <div>
                                  <div>{{item.name}} {{item.mobile}}</div>
                                  <div>{{item.province+" "+item.city+" "+item.area+" "+item.address}}</div>
                                </div>
                              </div>
                            </el-col>
                            <el-col :span="6" align="right">
                              <div>
                                <el-button plain size="mini" @click="select(index)">使用</el-button>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                    </div>
                    <el-button slot="reference" size="mini">
                      更改地址
                      <i class="fas fa-caret-down"></i>
                    </el-button>
                  </el-popover>
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-else class="lv3Text">
          未设置收货地址，去
          <el-link type="primary" @click="addFn() ">添加收货地址</el-link>
        </div>
      </div>
      <div style="margin-top:20px;">
        <el-table :data="[data]" border style="width: 100%">
          <el-table-column prop="date" width="100">
            <template slot-scope="scope">
              <img
                :src=" serve +  '/'+_.split(scope.row.images, ';', 1)"
                class="cover"
              />
            </template>
          </el-table-column>
          <el-table-column prop="date" label="商品信息">
            <template slot-scope="scope">
              <div class="lv2Text">{{scope.row.title}}</div>
              <div class="lv3Text">货号：{{scope.row.item_no}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="价格" width="100">
            <template slot-scope="scope">
              <div class="lv0Text">{{scope.row.integral}}积分</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="数量" width="80">
            <div align="center">x1</div>
          </el-table-column>
        </el-table>
      </div>
      <div class="lv0Text t2">应付总额：{{data.integral}}积分</div>
      <div class="lv0Text t2">我的积分：{{my}}积分</div>
    </div>
    <div align="right" style="padding:30px 20px;">
      <el-button type="primary" style="width:150px;" @click="submit">提交订单</el-button>
    </div>
    <el-dialog title="添加收货地址" :visible.sync="addDialog" width="50%" @closed="handleClose">
      <div>
        <el-row :gutter="40" class="row">
          <el-col :span="12">
            <el-input v-model="addform.name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="addform.a_mobile" placeholder="请输入手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="row">
          <el-col :span="8">
            <el-select v-model="addform.province" placeholder="请选择" @change="change1">
              <el-option
                v-for="(item,index) in sel1"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.city" placeholder="请选择" @change="change2">
              <el-option
                v-for="(item,index) in sel2"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.area" placeholder="请选择">
              <el-option
                v-for="(item,index) in sel3"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <el-input type="textarea" v-model="addform.address" placeholder="请输入详细地址"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addsubmit" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      addressV: null,
      form: {},
      address: "",
      data: "",
      addressList: [],
      hoverId: 0,
      a_id: null,
      my: 0,
      addform: {},
      addDialog: false,
      sel1: null,
      sel2: null,
      sel3: null,
      loading: false
    };
  },
  created() {
    //
    this.$store.state.cart_show = false;
    this.initData();
  },
  activated() {
    this.initData();
  },
  methods: {
    //
    handleClose() {
      this.addform = {};
    },
    addsubmit() {
      this.loading = true;
      this.addform.mobile = this.$cookies.get("user");
      this.addform.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/member/add_address", {
          params: this.addform
        })
        .then(res => {
          this.addDialog = false;
          this.loading = false;
          if (res.data.status == "success") {
            this.$message({
              message: "添加了一个新的收货地址",
              type: "success"
            });
            this.initData();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    change1(v) {
      this.axios.get(this.serve +"/city?name=" + v).then(res => {
        this.sel2 = res.data;
      });
    },
    change2(v) {
      this.axios.get(this.serve +"/area?name=" + v).then(res => {
        this.sel3 = res.data;
      });
    },
    addFn() {
      this.axios.get(this.serve +"/province").then(res => {
        this.sel1 = res.data;
        this.addDialog = true;
      });
    },
    submit() {
      if (_.toInteger(this.data.integral) <= _.toInteger(this.my)) {
        var product = {
          p_id: this.$route.query.p,
          images: this.data.images,
          item_no: this.data.item_no,
          number: 1,
          title: this.data.title,
          integral: this.data.integral
        };
        var json = {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token"),
          id: this.$route.query.id,
          product_id: this.$route.query.p,
          address_id: this.a_id,
          product_list: JSON.stringify([product])
        };
        this.axios
          .get(this.serve +"/member/conversion_product", {
            params: json
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$router.push("/user/finish_1");
            } else if (res.data.status == "error") {
              this.$message.error("请输入地址");
            }
          });
      } else {
        this.$message.error("积分不足");
      }
    },
    select(i) {
      this.addressV = false;
      let v = this.addressList[i];
      this.address =
        v.mobile +
        ";" +
        v.name +
        ";" +
        v.province +
        ";" +
        v.city +
        ";" +
        v.area +
        ";" +
        v.address;
      this.a_id = v.id;
    },
    initData() {
      this.axios
        .get(this.serve +"/member/get_integral_number", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.my = res.data;
        });

      this.axios
        .get(this.serve +"/member/get_default_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.address = res.data.data;
        });
      this.axios
        .get(this.serve +"/integral_detail", {
          params: {
            inte_id: this.$route.query.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
      this.axios
        .get(this.serve +"/member/get_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.addressList = res.data.data.results;
          var s = res.data.data.results;
          for (var i = 0; i < s.length; i++) {
            if (
              s[i].mobile +
                ";" +
                s[i].name +
                ";" +
                s[i].province +
                ";" +
                s[i].city +
                ";" +
                s[i].area +
                ";" +
                s[i].address ==
              this.address
            ) {
              this.a_id = s[i].id;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
#createOrder1 {
  .row {
    margin-bottom: 20px;
  }
  .t2 {
    text-align: right;
    font-size: 20px;
    font-weight: 500;
    padding: 20px 0;
    padding-right: 10px;
  }
  .cover {
    width: 80px;
  }
  .adr-btn {
    position: absolute;
    top: 50%;
    margin-top: -1em;
    right: 0;
  }
  padding-bottom: 50px;
  .t {
    padding: 20px 0;
  }
  .box2 {
    border: 1px solid #ddd;
    padding: 20px;
  }
  .box {
    border: 1px solid #ddd;
    background-color: #fff;
    padding: 20px 40px;
  }
  .address {
    line-height: 2em;
  }
}
</style>